import { Component, DestroyRef, inject, signal } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

// PrimeNg
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BotoneraApiService } from '../botonera.api.service';
import { IDatosAdicionales } from '../botonera.interface';
import { lastValueFrom } from 'rxjs';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-modal-datos-adicionales',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonModule, InputNumberModule, ToggleSwitchModule],
  templateUrl: './modal-datos-adicionales.component.html',
  styleUrls: ['./modal-datos-adicionales.component.scss'],
})
export class ModalDatosAdicionalesComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  apiService = inject(BotoneraApiService);
  destroyRef = inject(DestroyRef);

  form: FormGroup = new FormGroup({});
  isModoEdit = signal<boolean>(false);

  // Lista de campos de retenciones
  retencionCampos = [
    'ReteFuente',
    'ReteFuenteValor',
    'ReteIVA',
    'ReteIVAValor',
    'ReteICA',
    'ReteICAValor',
    'Procultura',
    'ProculturaValor'
  ];

  constructor() {
    this.buildForm(this.config.data);    
  }

  async crear() {
    // envia la solicitud al API
    const response = await lastValueFrom(this.apiService.PostDatosAdicionales(this.form.getRawValue()));

    // cierra el modal retornando la respuesta
    this.ref.close(response);
  }

  async editar() {
    // envia la solicitud al API
    const response = await lastValueFrom(this.apiService.PutDatosAdcionales(this.form.getRawValue()));

    // cierra el modal retornando la respuesta
    this.ref.close(response);
  }

  async eliminar() {
    // envia la solicitud al API
    const response = await lastValueFrom(this.apiService.DeletetDatosAdcionales(this.form.getRawValue()));

    // cierra el modal retornando la respuesta
    this.ref.close(response);
  }

  cerrarModal() {
    this.ref.close(false);
  }

  buildForm(data: IDatosAdicionales) {
    // detecta modo
    this.isModoEdit.set(data?.TipoDatoAdicional !== undefined ? true : false);

    // crea
    this.form = new FormGroup(
      {
        IdfdArchivo: new FormControl<number | null>(null),
        CodfdCuerpo: new FormControl<number | null>(null),
        CodfdPaso: new FormControl<number | null>(null),
        TipoDatoAdicional: new FormControl<number | null>(null),
        ReteFuente: new FormControl<number | null>(null),
        ReteFuenteValor: new FormControl<number | null>(null),
        ReteIVA: new FormControl<number | null>(null),
        ReteIVAValor: new FormControl<number | null>(null),
        ReteICA: new FormControl<number | null>(null),
        ReteICAValor: new FormControl<number | null>(null),
        Procultura: new FormControl<number | null>(null),
        ProculturaValor: new FormControl<number | null>(null),
        cmpoValoraPagar: new FormControl<number | null>(null),
        Observacion: new FormControl<string | null>(null),
        NoAplicanRetenciones: new FormControl<boolean | null>(null),
      }
    );

    // Deteccion de cambios
    this.detectarCambiosRetenciones();

    // setea
    this.form.patchValue(data);
  } 

  detectarCambiosRetenciones(): void {
    this.form.get('NoAplicanRetenciones')?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((noAplican) => {    
        if (noAplican) { 
          this.retencionCampos.forEach(campo => {
            const control = this.form.get(campo);
            if (control) {
              control.setValue(0, { emitEvent: false });
              control.disable({ emitEvent: false });
            }
          });
        } else {
          this.retencionCampos.forEach(campo => {
            const control = this.form.get(campo);
            control?.enable({ emitEvent: false });
          });
        }
  });
}
}
